module.exports = __webpack_public_path__ + "img/downloading.a21d6408.png";